export const APP_VERSION = '1.22.1-0';
